import Reveal from '@/components/base/Reveal';
import { starStories } from '@/mocks/gossip';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { tagClass } from '@/pages/home/components/tagStyle';

export default function StarSection() {
  const [featured, ...rest] = starStories;

  return (
    <section id="star" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="04 / Stars"
          title="明星八卦"
          desc="深夜被拍、临时取消、含糊回应——明星那边的每一条小动静，都被记进了这一页。"
        />

        <div className="grid gap-6 lg:grid-cols-[1.15fr_1fr] lg:gap-8">
          <Reveal className="h-full">
            <article className="group relative h-full cursor-pointer overflow-hidden rounded-lg">
              <div className="h-[320px] w-full md:h-[440px] lg:h-full lg:min-h-[440px]">
                <img
                  src={featured.img}
                  alt={`明星八卦：${featured.title}`}
                  title={`${featured.title} · 91吃瓜明星八卦`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/92 via-foreground-950/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <span className={`inline-flex rounded border px-2 py-0.5 text-[11px] ${tagClass(featured.tag)}`}>{featured.tag}</span>
                <p className="mt-3 text-xs text-background-100/70">{featured.name}</p>
                <h3 className="mt-1 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
                  {featured.title}
                </h3>
                <p className="mt-2 max-w-xl text-sm leading-relaxed text-background-100/85">{featured.summary}</p>
                <p className="mt-3 text-[11px] text-background-100/60">{featured.reads} 人正在围观</p>
              </div>
            </article>
          </Reveal>

          <div className="flex flex-col gap-4">
            {rest.map((story, i) => (
              <Reveal key={story.id} delay={i * 80} className="h-full">
                <article className="group flex h-full cursor-pointer gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 md:gap-5 md:p-5">
                  <div className="h-28 w-28 shrink-0 overflow-hidden rounded-md md:h-32 md:w-32">
                    <img
                      src={story.img}
                      alt={`明星八卦：${story.title}`}
                      title={`${story.title} · 91吃瓜明星八卦`}
                      className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className={`rounded border px-2 py-0.5 text-[11px] ${tagClass(story.tag)}`}>{story.tag}</span>
                      <span className="text-[11px] text-foreground-400">{story.reads} 阅读</span>
                    </div>
                    <p className="mt-2 text-xs text-foreground-500">{story.name}</p>
                    <h3 className="mt-1 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                      {story.title}
                    </h3>
                    <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">{story.summary}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}